import { sha256Hex } from './sha256.ts'

/**
 * Kanonisches JSON: Schlüssel rekursiv sortiert, Zahlen auf 4 Nachkommastellen gerundet,
 * undefined entfernt, keine Leerzeichen. Identische Implementierung in PHP
 * (App\Service\Editor\Design\DesignDocumentHasher); Fixtures in test/hash-fixtures.json.
 */
export function canonicalJson(value: unknown): string {
  return JSON.stringify(canonicalize(value))
}

function canonicalize(value: unknown): unknown {
  if (value === undefined) return null
  if (value === null) return null
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) return null
    const r = Math.round(value * 10000) / 10000
    return Object.is(r, -0) ? 0 : r
  }
  if (typeof value === 'string' || typeof value === 'boolean') return value
  if (Array.isArray(value)) return value.map(canonicalize)
  if (typeof value === 'object') {
    const src = value as Record<string, unknown>
    const out: Record<string, unknown> = {}
    for (const key of Object.keys(src).sort()) {
      if (src[key] === undefined) continue
      out[key] = canonicalize(src[key])
    }
    return out
  }
  return String(value)
}

export function documentHash(document: unknown): string {
  return sha256Hex(canonicalJson(document))
}

/**
 * renderHash = sha256(canonical(document) + '|' + canonical(target) + '|' + rendererVersion).
 * Ändert sich der Renderer (Chromium/Paket), entstehen neue Hashes statt gemischter Ausgaben.
 */
export function renderHash(document: unknown, target: unknown, rendererVersion: string): string {
  return sha256Hex(`${canonicalJson(document)}|${canonicalJson(target)}|${rendererVersion}`)
}
